import { SVGProps } from 'react';

const PublishingCalIcon = ({
  height = '25px',
  width = '25px',
  className,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 25 24'
    className={className ? className : 'fill-current stroke-current'}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.44678 8.74121C1.44678 8.18893 1.89449 7.74121 2.44678 7.74121H22.3568C22.9091 7.74121 23.3568 8.18893 23.3568 8.74121C23.3568 9.2935 22.9091 9.74121 22.3568 9.74121H2.44678C1.89449 9.74121 1.44678 9.2935 1.44678 8.74121Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.46191 0.602783C7.0142 0.602783 7.46191 1.0505 7.46191 1.60278V3.64278C7.46191 4.19507 7.0142 4.64278 6.46191 4.64278C5.90963 4.64278 5.46191 4.19507 5.46191 3.64278V1.60278C5.46191 1.0505 5.90963 0.602783 6.46191 0.602783Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.5918 0.602783C19.1441 0.602783 19.5918 1.0505 19.5918 1.60278V3.64278C19.5918 4.19507 19.1441 4.64278 18.5918 4.64278C18.0395 4.64278 17.5918 4.19507 17.5918 3.64278V1.60278C17.5918 1.0505 18.0395 0.602783 18.5918 0.602783Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.40186 4.64282C3.97742 4.64282 3.40186 5.08909 3.40186 5.94598V19.765C3.40186 20.6218 3.97742 21.0681 4.40186 21.0681H20.4019C20.8263 21.0681 21.4019 20.6218 21.4019 19.765V5.94598C21.4019 5.08909 20.8263 4.64282 20.4019 4.64282H4.40186ZM1.40186 5.94598C1.40186 4.25888 2.61715 2.64282 4.40186 2.64282H20.4019C22.1866 2.64282 23.4019 4.25888 23.4019 5.94598V19.765C23.4019 21.4521 22.1866 23.0681 20.4019 23.0681H4.40186C2.61715 23.0681 1.40186 21.4521 1.40186 19.765V5.94598Z'
    />
    <path d='M19.4019 11.6809H17.4019C17.1257 11.6809 16.9019 11.9048 16.9019 12.1809V14.1809C16.9019 14.4571 17.1257 14.6809 17.4019 14.6809H19.4019C19.678 14.6809 19.9019 14.4571 19.9019 14.1809V12.1809C19.9019 11.9048 19.678 11.6809 19.4019 11.6809Z' />
    <path d='M15.4019 15.8767H13.4019C13.1257 15.8767 12.9019 16.1006 12.9019 16.3767V18.3767C12.9019 18.6529 13.1257 18.8767 13.4019 18.8767H15.4019C15.678 18.8767 15.9019 18.6529 15.9019 18.3767V16.3767C15.9019 16.1006 15.678 15.8767 15.4019 15.8767Z' />
    <path d='M15.4019 11.6809H13.4019C13.1257 11.6809 12.9019 11.9048 12.9019 12.1809V14.1809C12.9019 14.4571 13.1257 14.6809 13.4019 14.6809H15.4019C15.678 14.6809 15.9019 14.4571 15.9019 14.1809V12.1809C15.9019 11.9048 15.678 11.6809 15.4019 11.6809Z' />
    <path d='M11.4019 11.6809H9.40186C9.12571 11.6809 8.90186 11.9048 8.90186 12.1809V14.1809C8.90186 14.4571 9.12571 14.6809 9.40186 14.6809H11.4019C11.678 14.6809 11.9019 14.4571 11.9019 14.1809V12.1809C11.9019 11.9048 11.678 11.6809 11.4019 11.6809Z' />
    <path d='M11.4019 15.8767H9.40186C9.12571 15.8767 8.90186 16.1006 8.90186 16.3767V18.3767C8.90186 18.6529 9.12571 18.8767 9.40186 18.8767H11.4019C11.678 18.8767 11.9019 18.6529 11.9019 18.3767V16.3767C11.9019 16.1006 11.678 15.8767 11.4019 15.8767Z' />
    <path d='M7.40186 15.8767H5.40186C5.12571 15.8767 4.90186 16.1006 4.90186 16.3767V18.3767C4.90186 18.6529 5.12571 18.8767 5.40186 18.8767H7.40186C7.678 18.8767 7.90186 18.6529 7.90186 18.3767V16.3767C7.90186 16.1006 7.678 15.8767 7.40186 15.8767Z' />
  </svg>
);

export default PublishingCalIcon;
